import "./HomeTestimonial.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const testimonials = [
  {
    name: "Sarah Mitchell ",
    role: "Senior Travel Consultant ",
    image: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/home-testimonial/sarah.webp",
    desc: "We had a group arriving in Dubai during a busy period and needed a few changes close to departure. The team handled everything quickly and kept us updated throughout. That level of support is why we continue working together. ",
  },
  {
    name: "Ahmed Al Rashid ",
    role: "Product Manager ",
    image: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/home-testimonial/ahmad%20al%20rashid.webp",
    desc: "One thing we appreciate is that they don't overcommit. If something isn't available, they suggest alternatives straight away. It saves a lot of time and makes planning much smoother for our team. ",
  },
  {
    name: "Jessica Tan ",
    role: "Operations Director ",
    image: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/home-testimonial/jessica.webp",
    desc: "We've used Blueberry for both Singapore and Malaysia programs. Communication is straightforward, and we rarely have to chase updates. The booking process feels organized from the start. ",
  },
  {
    name: "Priya Sharma ",
    role: "Head of International Holidays ",
    image: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/home-testimonial/priya.webp",
    desc: "During peak holiday seasons, response times become really important. Their team has been consistent with updates, confirmations, and handling client requests, which helps us manage bookings with less stress. ",
  },
      {
      name: "David Mwangi ",
      role: "Business Development Manager ",
      image: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/home-testimonial/david.webp",
      desc: "We've worked together on several itineraries involving East Africa and the UAE. The coordination has been reliable, especially when managing multiple services across different destinations and suppliers. ",
    },
];

function HomeTestimonial() {
  return (
    <section className="testimonial-section standard-padding">
      <div className="testimonial-header-wrapper">
        <h1 className="testimonial-title heading">
         Experiences Shared by Our Partners 
        </h1>
      </div>

      <Swiper
        modules={[
            Autoplay,
             Pagination]}
        spaceBetween={24}
        loop={true}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
          0: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
          1400: {
            slidesPerView: 4,
          },
        }}
      >
        {testimonials.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="testimonial-card">
              <div className="testimonial-top">
                <div className="testimonial-profile">
                  <div className="testimonial-image">
                    <img src={item.image} alt={item.name} />
                  </div>

                  <div className="testimonial-info">
                    <h4 className="testimonial-name">{item.name}</h4>

                    <span className="testimonial-role">{item.role}</span>
                  </div>
                </div>

                <div className="testimonial-quote">
                  <img src="/assets/quote.svg" alt="quote" />
                </div>
              </div>

              <div className="testimonial-stars">
                {[...Array(5)].map((_, index) => (
                  <img key={index} src="/assets/client-star.svg" alt="star" />
                ))}
              </div>

              <p className="testimonial-text">{item.desc}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default HomeTestimonial;
